
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/open-position",
      function () {
        return require("private-next-pages/open-position/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/open-position"])
      });
    }
  